import type { MediaConnector, SyncJobStatusResponse } from '@/entities/media-connector';

export interface AccountRowProps {
  account: MediaConnector;
  syncStatus?: SyncJobStatusResponse;
  onEdit: () => void;
  onDelete: () => void;
  onToggle: (checked: boolean) => void;
  onSync: () => void;
  onTest: () => void;
  isToggling: boolean;
  isSyncing: boolean;
  isTesting: boolean;
}

/** Shared by the status badge and both capability badges. */
export const STATUS_BADGE_CLASSES: Record<string, string> = {
  success:
    'border-green-600/30 bg-green-50 text-green-700 dark:bg-green-950/30 dark:text-green-400',
  warning:
    'border-yellow-600/30 bg-yellow-50 text-yellow-700 dark:bg-yellow-950/30 dark:text-yellow-400',
  destructive: 'border-red-600/30 bg-red-50 text-red-700 dark:bg-red-950/30 dark:text-red-400',
  muted: 'border-border-light bg-muted text-muted-foreground',
  neutral: 'border-border-light bg-muted text-muted-foreground',
};
